import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    caseSubTopbar: {
      backgroundColor: theme.vars.palette.background.elevation1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      zIndex: 2,
      position: 'sticky'
    },
    caseSubTopbarBottom: {
      ...(isLayoutMobile && {
        position: 'relative',
        width: '100vw'
      })
    },
    bottomContent: {
      position: 'relative',
      backgroundColor: theme.vars.palette.background.elevation2,
      borderBottom: `1px solid ${theme.vars.palette.border.light}`,
      borderTop: `1px solid ${theme.vars.palette.border.light}`,
      boxShadow: isLayoutMobile ? 'none' : theme.shadows[2],
      display: 'flex'
    },
    bottomContentSection: {
      display: 'flex',
      flex: 1,
      minHeight: '3.5rem',
      padding: theme.spacing(0, 0, 0, 2),
      alignItems: 'center',
      '& > *': {
        minWidth: '7rem',
        paddingLeft: theme.spacing(1)
      },
      ...(!isLayoutMobile && {
        marginLeft: `${theme.spacing(3)}`
      }),
      '.kvResponsiveContainer': {
        columnGap: theme.spacing(4)
      },
      '.kvResponsive': {
        width: 'auto',
        padding: '0.375rem 0 0.5rem 0'
      },
      '.kvLabel': {
        color: theme.vars.palette.text.secondary,
        fontSize: '0.75rem'
      },
      '.kvValue': {
        lineHeight: '1.5rem'
      },
      [theme.breakpoints.down('lg')]: {
        backgroundImage: `repeating-linear-gradient(0deg, ${theme.vars.palette.border.light}, ${theme.vars.palette.border.light} 1px, transparent 1px, transparent 3.6rem)`,
        backgroundSize: '100% 3.55rem',
        '.kvResponsive': {
          minWidth: '7rem'
        }
      }
    },
    bottomContentBackButton: {
      alignItems: 'center',
      backgroundColor: theme.vars.palette.background.elevation3,
      borderRadius: 0,
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      minWidth: theme.spacing(3),
      padding: 0,
      position: 'absolute',
      top: 0,
      '&:hover': {
        opacity: 0.8
      }
    }
  }));

export default useStyles;
